import { PaymentCollectorRepository } from "@domain/payment-collector/repositories/payment-collector.repository";
import { PaymentCollectorRepositoryService } from "../repositories/payment-collector.service";

export const PaymentCollectorProvider = [
  {
    provide: PaymentCollectorRepository,
    useClass: PaymentCollectorRepositoryService,
  },
];